"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { AlertDialog, Flex } from "@radix-ui/themes";
import { AlertDialogContent, DestructiveButton, SecondaryButton, } from "./elements";
import { useDeleteTotpFactors } from "../api";
import { useSecuritySettings } from "./use-security-settings";
import { ElevatedAccess } from "./elevated-access";
import { SaveButton } from "./save-button";
import { useDialogClose } from "./use-dialog-close";
export function ResetMfaDialog({ children, isPasswordSet, ...props }) {
    const [open, setOpen] = React.useState(false);
    const handleClose = React.useCallback(() => {
        setOpen(false);
    }, []);
    return (_jsxs(AlertDialog.Root, { ...props, open: open, onOpenChange: setOpen, children: [_jsx(AlertDialog.Trigger, { children: children }), _jsx(AlertDialogContent, { maxWidth: "480px", children: _jsx(ElevatedAccess, { type: "alert", children: _jsx(Content, { onClose: handleClose, isPasswordSet: isPasswordSet }) }) })] }));
}
function Content({ onClose, isPasswordSet, }) {
    const securitySettings = useSecuritySettings();
    const resetMfa = useDeleteTotpFactors();
    const onSubmitForm = () => {
        resetMfa.mutate();
    };
    useDialogClose(resetMfa.isSuccess, () => {
        securitySettings.update("Mfa", false);
    });
    return (_jsxs(_Fragment, { children: [_jsx(AlertDialog.Title, { children: "Disable multi-factor authentication?" }), _jsxs(AlertDialog.Description, { children: ["Turning off MFA will remove the additional layer of security on your account.", " ", isPasswordSet
                        ? "We will only ask for your password during sign-in."
                        : "We will not ask for additional verification during sign-in."] }), _jsx(Flex, { gap: "3", justify: "end", mt: "5", asChild: true, children: _jsxs("form", { onSubmit: (event) => {
                        event.preventDefault();
                        onSubmitForm();
                    }, children: [_jsx(AlertDialog.Cancel, { children: _jsx(SecondaryButton, { disabled: resetMfa.isPending || resetMfa.isSuccess, children: "Cancel" }) }), _jsx(SaveButton, { asChild: true, loading: resetMfa.isPending, done: resetMfa.isSuccess, onDone: onClose, children: _jsx(DestructiveButton, { type: "submit", children: "Disable" }) })] }) })] }));
}
//# sourceMappingURL=reset-mfa-dialog.js.map